<div class="bottom-sheet-bg-overlay" (click)="close()"></div>
<div class="bottom-sheet-container" [@slideUpToggle]>
  <div>
    <button class="bottom-sheet-button" (click)="close()"></button>
    <div class="bottom-sheet-content">
      <ng-content></ng-content>
    </div>
  </div>
</div>
